import { useState } from "react";
import { useChannelStore } from "../../../stores/channelStore";
import { useModalStore } from "../../../stores/modalStore";
import { X } from "lucide-react";

export function CreateChannelModal() {
  const isOpen = useModalStore((state) => state.isOpen && state.type === "createChannel");
  const onClose = useModalStore((state) => state.onClose);
  const addChannel = useChannelStore((state) => state.addChannel);

  const [channelName, setChannelName] = useState("");
  const [channelCategory, setChannelCategory] = useState("Development");
  const [channelType, setChannelType] = useState("text");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (!channelName.trim()) return;

    const newChannel = {
      id: channelName.toLowerCase().replace(/\s+/g, "-"),
      name: channelName,
      category: channelCategory,
      type: channelType,
    };

    addChannel(newChannel);
    setChannelName("");
    setChannelCategory("Development");
    setChannelType("text");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-[#313338] rounded-lg p-0 w-full max-w-md flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-[#1a1a1a]">
          <h2 className="text-lg font-bold">Create Channel</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-[#2c2f33] rounded transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold mb-2">Channel Name</label>
            <input
              type="text"
              value={channelName}
              onChange={(e) => setChannelName(e.target.value)}
              placeholder="e.g., announcements"
              className="w-full bg-[#1a1a1a] border border-[#404249] rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">Category</label>
            <select
              value={channelCategory}
              onChange={(e) => setChannelCategory(e.target.value)}
              className="w-full bg-[#1a1a1a] border border-[#404249] rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500"
            >
              <option value="Announcements">Announcements</option>
              <option value="Development">Development</option>
              <option value="Support">Support</option>
              <option value="Voice Channels">Voice Channels</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">Type</label>
            <select
              value={channelType}
              onChange={(e) => setChannelType(e.target.value)}
              className="w-full bg-[#1a1a1a] border border-[#404249] rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-blue-500"
            >
              <option value="text">Text</option>
              <option value="voice">Voice</option>
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-4 border-t border-[#1a1a1a]">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-400 hover:text-white transition text-sm font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handleCreate}
            disabled={!channelName.trim()}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white rounded transition text-sm font-medium"
          >
            Create Channel
          </button>
        </div>
      </div>
    </div>
  );
}
